import { ExcelStyle } from 'ag-grid-community';

export const LICENSE_KEY = 'PLACEHOLDER';

export const DEFAULT_COLUMN_DEFINITIONS = {
    sortable: true,
    filter: true,
    resizable: true,
    floatingFilter: true
};

export const DEFAULT_STATUS_BAR = {
    statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agSelectedRowCountComponent' }
    ]
};

export const DEFAULT_GROUP_DISPLAY_TYPE = 'groupRows';

export const DEFAULT_ROW_SELECTION = 'multiple';

export const EXCEL_DATE_STYLE_ID = 'ExcelDate';

export const DEFAULT_EXCEL_EXPORT_CONFIG: ExcelStyle[] = [
    {
        id: EXCEL_DATE_STYLE_ID,
        dataType: 'DateTime',
        numberFormat: { format: 'yyyy-mm-dd' }
    }
];

export const LINK_COLOR = '#077398';
